import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withKeys as _withKeys, unref as _unref, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "utterance-list-item" }
const _hoisted_2 = { class: "utterance-item" }
const _hoisted_3 = ["id", "placeholder", "disabled"]
const _hoisted_4 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_5 = {
  key: 1,
  class: "help is-danger"
}

import { UtteranceViewModel } from '@/features/bots/models/intents/utteranceViewModel';
import { computed, PropType, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import VuelidateUtil from '@shared/util/vuelidateUtil';


export default /*@__PURE__*/_defineComponent({
  __name: 'UtteranceListItem',
  props: {
  utterance: {
    type: Object as PropType<UtteranceViewModel>,
    required: true,
  },
  allUtterances: {
    type: Array as PropType<UtteranceViewModel[]>,
    required: true,
  },
  term: {
    type: String,
    default: 'utterance',
  },
  isEditable: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:utterance", "delete", "move-to-next"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const localUtterance = computed({
  get: () => props.utterance,
  set: (value) => emit('update:utterance', value),
});

const inputElement = ref<HTMLInputElement | null>(null);

const placeholderText = computed(() => `Enter your ${props.term}`);

const validations = {
  localUtterance: {
    text: {
      required,
      isUnique(value: string) {
        return props.allUtterances.filter((u) => u.text === value).length <= 1;
      },
    },
  },
};

const $v = useVuelidate(validations, { localUtterance });
const isTextRequiredInvalid = computed(() => VuelidateUtil.isRequiredInvalid($v, (v) => v.localUtterance.text));
const isTextUniqueInvalid = computed(() =>
  VuelidateUtil.isValidationInvalid($v, (v) => v.localUtterance.text, 'isUnique'),
);

__expose({
  focus: () => inputElement.value?.focus(),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: 'input-' + __props.utterance.id,
        ref_key: "inputElement",
        ref: inputElement,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localUtterance.value.text) = $event)),
        class: "input",
        type: "text",
        placeholder: placeholderText.value,
        required: "",
        onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('move-to-next', __props.utterance.id)), ["enter"])),
        onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_unref($v).localUtterance.text.$touch())),
        disabled: !__props.isEditable
      }, null, 40, _hoisted_3), [
        [_vModelText, localUtterance.value.text]
      ]),
      _createElementVNode("a", {
        class: "delete is-small",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('delete', __props.utterance.id)))
      })
    ]),
    (isTextRequiredInvalid.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "The " + _toDisplayString(__props.term) + " text must not be empty", 1))
      : _createCommentVNode("", true),
    (isTextUniqueInvalid.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, "The " + _toDisplayString(__props.term) + " must be unique", 1))
      : _createCommentVNode("", true)
  ]))
}
}

})